module.exports = __webpack_public_path__ + "static/media/bottega.56dbc1b5.jpg";